export default "__VITE_ASSET__Cev0S4qL__"